import styled from 'styled-components';

export const Main = styled.div`
  margin: 0 0 40px 0;
  position: relative;
`;

export const Invite = styled.p`
  margin: ${props => props.theme.spacing.default} 0;
`;

export const InvWrapper = styled.div`
  margin-top: 20px;
`;

export const NoMembers = styled.p`
  padding: 20px 0;
  font-size: 0.925em;
`;
